<template>
  <div id="CaracterizacionView" :key="keyYear">
  <!-- === HEADER SUPERIOR === -->
    <TopPanel
      :tabs="[
        { label: 'Caracterización', path: '/caracterizacion/' },
        { label: 'Rating', path: '/rating/' },
        { label: 'Materia prima', path: '/materiaprima/' }
      ]"
      @year-changed="onYearChanged"
    /> 
  <!-- === CUERPO PRINCIPAL === -->
  <div id="wrapper" class="mt-2">
      <div id="wrapper-left">
        
        <!-- === TOP PANEL === -->
        <div id="top-panel-container">
          <div id="top-panel">
            <v-card id="top-panel-1">
              <h4 class="gray-font">Productores Participantes</h4>
              <DonutChart
                :key="selectedYear"
                :data_chart="{
                  serie: chartSeries,
                  categories: chartOptions.labels,
                  colors: ['#103E8E', '#5390EA']
                }"
              />
            </v-card>

            <v-card class="d-flex flex-column text-center" id="top-panel-2">
              <h4 class="gray-font">Tipo Empresa</h4>
              <p class="gray-font">Persona Jurídica</p>
              <p class="number">{{ currentYearData.resultados.tipoEmpresa.juridica }}</p>
              <p class="gray-font">Persona Natural</p>
              <p class="number">{{ currentYearData.resultados.tipoEmpresa.natural }}</p>
            </v-card>

            <v-card class="d-flex flex-column text-center" id="top-panel-3">
              <h4 class="gray-font">Tamaño Empresa</h4>
              <p class="gray-font">Microempresas</p>
              <p class="gray-font">{{ currentYearData.resultados.microempresa.rangoUF }}</p>
              <p class="number">{{ currentYearData.resultados.microempresa.porcentaje }}%</p>
            </v-card>

            <v-card class="text-center" id="top-panel-4">
              <h4 class="gray-font">Propiedad</h4>
              <StackColumn :data_chart="data_chart" />
            </v-card>
          </div>
        </div>

        <!-- === PANEL PRODUCTOS === -->
        <v-card id="middle-panel">
          <h4 class="gray-font ml-2" style="text-align: left !important;">Productos</h4>
          <InfoCardTreeMap
            :key="selectedYear" 
            :data="maptreeData"
          />
        </v-card>

        <!-- === PANEL INFERIOR UNIFORME === -->
        <div id="bottom-panel">
          <v-card class="uniform-card">
            <div class="bottom-card-inner">
              <h4 class="bottom-title">Producción Anual (TON)</h4>
              <p class="bottom-value">
                Total: {{ currentYearData.resultados.totalProduccion }}
              </p>
            </div>
          </v-card>

          
          <v-card class="uniform-card">
            <div class="bottom-card-inner">
              <h4 class="bottom-title">Consumo Agua Anual (M³)</h4>
              <p class="bottom-value">
                Total: {{ currentYearData.resultados.totalAgua }}
              </p>
            </div>
          </v-card>

          <v-card class="uniform-card">
            <div class="bottom-card-inner">
              <h4 class="bottom-title">Rango Superficie Cultivada (Ha)</h4>
              <p class="bottom-line">
                Menos de 1 Ha:
                <span class="highlight">{{ currentYearData.resultados.superficie['<1ha'].toFixed(2) }}%</span>
              </p>
              <p class="bottom-line">
                1 - 3.9 Ha:
                <span class="highlight">{{ currentYearData.resultados.superficie['1-3.9ha'].toFixed(2) }}%</span>
              </p>
              <p class="bottom-line">
                4 - 6.0 Ha:
                <span class="highlight">{{ currentYearData.resultados.superficie['4-6ha'].toFixed(2) }}%</span>
              </p>
              <p class="bottom-line">
                10 - 12.9 Ha:
                <span class="highlight">{{ currentYearData.resultados.superficie['10-12.9ha'].toFixed(2) }}%</span>
              </p>
            </div>
          </v-card>
        </div>
      </div>

      <!-- === PANEL DERECHO (MAPA) === -->
      <div id="wrapper-right">
        <v-card class="py-5" id="card-map">
          <mapa_regiones
            :key="selectedYear"
            :data_regiones="data_regiones"
            :data_comunas="data_comunas"
          />
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import DonutChart from '../components/charts/DonutChart.vue'
import InfoCardTreeMap from '../components/dashboardComponents/infoCardTreeMap.vue'
import StackColumn from '../components/charts/stackColumn.vue'
import mapa_regiones from '../components/maps/mapa_regiones.vue'
import YearPicker from '@/components/YearPicker.vue'
import { mockData } from '@/data/mockData.js'
import { mapState, mapGetters } from 'vuex'
import TopPanel from "@/components/layout/TopPanel.vue";


export default {
  name: 'CaracterizacionView',
  components: {
    DonutChart,
    YearPicker,
    TopPanel,
    InfoCardTreeMap,
    mapa_regiones,
    StackColumn,
  },

  computed: {
    // ✅ Año desde el store global
    ...mapState(['selectedYear']),
    ...mapGetters(['availableYears']),

    // ✅ Datos actualizados según año
    currentYearData() {
      return mockData[this.selectedYear] || mockData['2024'] || { resultados: {} }
    },

    // === Gráfico Donut ===
    chartSeries() {
      const genero = this.currentYearData.resultados?.genero || { mujeres: 0, hombres: 0 }
      const mujeres = Number(genero.mujeres) || 0
      const hombres = Number(genero.hombres) || 0
      return [mujeres, hombres]
    },
    chartOptions() {
      return { chart: { type: 'donut' }, labels: ['Mujeres', 'Hombres'] }
    },

    // === Treemap ===
    maptreeData() {
      const productos = this.currentYearData.productos || []
      return productos.map((p, i) => {
        const nombre = p.producto || p.nombre || `Producto ${i + 1}`

        return {
          x: nombre,
          y: this.safeNumber(p.valor || p.produccion || 0),

          producto: nombre,
          produccion: p.produccion || p.valor || '-',
          pertinencia: p.pertinencia || '-',
          practica: p.practica || '-',
          sellos: p.sellos || '-',
        }
      })
    },

    // === Stack Column ===
    data_chart() {
      const propiedad = this.currentYearData.resultados?.propiedad || {}

      const safe = (v) => {
        // Convertimos a string, limpiamos caracteres no numéricos
        const cleaned = String(v).replace(/[^0-9.-]/g, '')
        const n = Number(cleaned)
        return isNaN(n) ? 0 : n
      }

      return {
        series: [
          { name: 'Propietario', data: [safe(propiedad.propietario)] },
          { name: 'Arrendatario', data: [safe(propiedad.arrendatario)] },
          { name: 'Comodato', data: [safe(propiedad.comodato)] },
        ],
        categorias: propiedad.categorias || ['Propiedad'],
      }
    },


    // === Mapas ===
    data_regiones() {
      return this.currentYearData.ubicacion?.regiones || []
    },
    data_comunas() {
      const productores = this.currentYearData.ubicacion?.productores || []
      return productores.map((p) => ({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: p.coordinates },
        properties: {
          data_file: JSON.stringify({
            nombre_productor: p.productor,
            region: p.region,
            ubicacion: p.ubicacion,
            distancia_arica: p.distancia_arica,
            productos: Array.isArray(p.productos)
              ? p.productos.join(', ')
              : p.productos,
          }),
        },
      }))
    },
  },

  data() {
    return {
      activeTab: 0,
      keyYear: 0, // ✅ forzar remonte del componente
      tabs: [
        { label: 'Caracterización', path: '/caracterizacion/' },
        { label: 'Rating', path: '/rating/' },
        { label: 'Materia Prima', path: '/materiaprima/' },
      ],
    }
  },

  watch: {
    // ✅ Si cambia el año, actualizamos la key para forzar el remonte de todos los gráficos
    selectedYear(newYear) {
      console.log(`🔄 Caracterización actualizada para el año ${newYear}`)
      this.keyYear++ // fuerza re-render
    },
  },

  methods: {
    navigateTo(index) {
      this.activeTab = index
      const path = this.tabs[index].path
      // ✅ Evitar navegación duplicada (cuando ya estás en la vista)
      if (this.$route.path !== path) {
        this.$router.push({ path })
      }
    },
    onYearChanged(newYear) {
      console.log(`📅 Cambio de año en Caracterización: ${newYear}`)
      this.$store.commit('setSelectedYear', newYear)
      this.$store.dispatch('hydrateProducersByYear', newYear)
      //this.$store.commit('setSelectedProducer', null)
    },
    safeNumber(v) {
      const n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    }
  },
}
</script>


<style scoped>
/* === LAYOUT PRINCIPAL === */
#CaracterizacionView {
  min-height: 100vh; /* permite crecer más allá del viewport */
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  overflow-y: auto; /* 👈 habilita scroll vertical */
  overflow-x: hidden;
}

/* === WRAPPER GENERAL === */
#wrapper {
  display: flex;
  flex: 1;
  gap: 6px;
  padding: 4px;
  align-items: stretch;
}

/* === COLUMNA IZQUIERDA (TOP + TREE + BOTTOM) === */
#wrapper-left {
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 6px;
  height: auto; /* 👈 permite expansión natural */
}

/* === COLUMNA DERECHA (MAPA) === */
#wrapper-right {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* ====== TOP PANEL ====== */
#top-panel {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  align-items: stretch;
}

#top-panel > * {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  height: 100%;
  padding: 10px 6px;
}

/* ====== MIDDLE PANEL (TreeMap Productos) ====== */
#middle-panel {
  flex: none; /* 👈 evita que se expanda infinito */
  min-height: 340px;
  max-height: 70vh; /* 👈 ocupa hasta el 70% de la pantalla */
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  overflow: hidden; /* mantiene bordes limpios */
  position: relative;
  z-index: 2;
}

#middle-panel .v-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  height: 100%;
  overflow: hidden;
}

/* ====== BOTTOM PANEL ====== */
#bottom-panel {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  align-items: stretch;
  position: relative;
  z-index: 1;
}

.uniform-card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  min-height: 150px;
  padding: 10px;
}

.bottom-card-inner {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
}

.bottom-title {
  font-size: clamp(1rem, 1.1vw, 1.3rem);
  font-weight: 600;
  color: #7f7f7f;
  margin-bottom: 8px;
  text-align: center;
}

.bottom-value {
  font-size: clamp(1.3rem, 1.5vw, 2rem);
  font-weight: 700;
  color: #2F48A3;
  margin: 0;
  text-align: center;
}

.bottom-line {
  margin: 2px 0;
  font-size: clamp(0.95rem, 1vw, 1.1rem);
  color: #7F7F7F;
}

.highlight {
  color: #2F48A3;
  font-weight: 600;
}

/* ====== TIPOGRAFÍA GENERAL ====== */
.number {
  font-size: clamp(1.2rem, 1.4vw, 2rem);
  font-weight: 700;
  color: #2F48A3;
  margin: 0;
  text-align: center;
}

.gray-font {
  color: #7F7F7F;
  font-size: clamp(0.95rem, 1vw, 1.1rem);
  text-align: center;
}

h4.gray-font {
  margin: 0 0 6px 0;
  text-align: center;
  font-size: clamp(1rem, 1.1vw, 1.3rem);
  font-weight: 600;
}

/* --- Header --- */
.header-bar {
  display: flex;
  align-items: center;
}

.header-bar h2 {
  margin: 0;
  padding: 0;
  line-height: 40px;
  font-size: clamp(16px, 1.2vw, 22px);
}

/* ====== RESPONSIVIDAD ====== */
@media (max-width: 1600px) {
  #top-panel {
    grid-template-columns: repeat(2, 1fr);
  }
  #bottom-panel {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 1024px) {
  #wrapper {
    flex-direction: column;
  }
  #top-panel {
    grid-template-columns: 1fr;
  }
  #bottom-panel {
    grid-template-columns: 1fr;
  }
  #middle-panel {
    max-height: none; /* ocupa espacio total en pantallas pequeñas */
  }
}
</style>
